export interface UniqueRuleKeys {
  customerBk: string;
  systemBk: string;
  ruleBk: string;
}

export enum RuleType {
  BMSRule = 'bms_rule',
  StateRule = 'state_rule',
  ThresholdRule = 'threshold_rule',
}
